/* ============================================================
   TRADIE — Move the size selector up next to the colour swatches
   Block order in the section renders colours (<product-variant-
   picker>) well before the size buttons (<pf-size-selector>), with
   the price header, bundle selector and a size-chart link in
   between. Reordering via templates/product.json's block_order is
   risky to hand-edit (huge generated file, easy to corrupt), so
   this repositions the already-rendered elements instead — same
   approach used for price-title-layout.js and mobile-header-reorder.js
   elsewhere in this theme.

   Moves <pf-size-selector> directly after <product-variant-picker>
   (the colour swatches), and brings the "Size chart" link along
   with it, on the same row, left-aligned flush with the size
   buttons below it.

   The "Size chart" link (#lavar-size-chart, confirmed via DevTools)
   ships from its app as a `position: fixed` floating tab pinned to
   the edge of the viewport — that's why it renders as a vertical
   strip. Reparenting a fixed-position element in the DOM has NO
   visual effect on its own (fixed positioning is relative to the
   viewport, not its DOM parent), so size-selector-restyle.css also
   strips that fixed/vertical styling back to normal inline flow —
   the DOM move here only controls where it sits once un-fixed.

   NOTE: this used to also inject a "Size: X" label (reflecting the
   currently selected size) into the chart-link row. Removed per
   request — the row now just carries the "Size chart" link,
   left-aligned by size-selector-restyle.css.

   Re-runs on any DOM change (via MutationObserver) since switching
   colour variant can re-render parts of the product info column.
   Idempotent — no-ops once already positioned correctly.
   ============================================================ */

function pfRepositionSizeSelector() {
  var colorPicker = document.querySelector('product-variant-picker');
  var sizeSelector = document.querySelector('pf-size-selector');
  var chartLink = document.getElementById('lavar-size-chart') || document.querySelector('.size-chart');

  if (!colorPicker || !sizeSelector || !colorPicker.parentNode) return;

  var sizeSelectorInPlace =
    sizeSelector.previousElementSibling === colorPicker ||
    (chartLink &&
      sizeSelector.previousElementSibling === chartLink &&
      chartLink.previousElementSibling === colorPicker);

  var chartInPlace = !chartLink || chartLink.classList.contains('pf-size-chart-link');

  if (!(sizeSelectorInPlace && chartInPlace)) {
    if (chartLink) {
      chartLink.classList.add('pf-size-chart-link');
      colorPicker.parentNode.insertBefore(chartLink, colorPicker.nextSibling);
      colorPicker.parentNode.insertBefore(sizeSelector, chartLink.nextSibling);
    } else {
      colorPicker.parentNode.insertBefore(sizeSelector, colorPicker.nextSibling);
    }
  }
}

document.addEventListener('DOMContentLoaded', pfRepositionSizeSelector);

var pfSizeReposScheduled = false;
var pfSizeReposObserver = new MutationObserver(function () {
  if (pfSizeReposScheduled) return;
  pfSizeReposScheduled = true;
  requestAnimationFrame(function () {
    pfSizeReposScheduled = false;
    pfRepositionSizeSelector();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  pfSizeReposObserver.observe(document.body, { childList: true, subtree: true });
});
